import { render } from "./FollowedBusinesses.vue?vue&type=template&id=68a314aa&scoped=true"
import script from "./FollowedBusinesses.vue?vue&type=script&lang=js"
export * from "./FollowedBusinesses.vue?vue&type=script&lang=js"

import "./FollowedBusinesses.vue?vue&type=style&index=0&id=68a314aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a314aa"]])

export default __exports__